<template>
  <div class="alert-dialog-content">
    <slot />
  </div>
</template>

<script setup lang="ts">
// Add your component logic here
</script>

<style scoped>
.alert-dialog-content {
  /* Add your styles here */
}
</style>
